import { element } from 'angular';
export var ScrollToItemDirective = [
    function () {
        return {
            link: function ($scope, $element, $attributes) {
                var clickFn = function () {
                    var scrollToElement = element($attributes.scrollTo);
                    if (scrollToElement.length === 0) {
                        return;
                    }
                    element('html,body').animate({ scrollTop: scrollToElement.offset().top }, 'slow');
                };
                if ($attributes.scrollToEnabled !== 'false') {
                    $element.on('click', clickFn);
                    $scope.$on('$destroy', function () {
                        $element.off('click', clickFn);
                    });
                }
            },
            restrict: 'A',
        };
    },
];
